import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  enable_user_account,
  signup_reactivate_account,
  signup_hard_delete_account,
} from "../api/serverWrapper";

export const useAccountStatusGate = () => {
  const navigate = useNavigate();
  const [accountDeletedPopup, setAccountDeletedPopup] = useState(false);
  const [accountDisabledPopup, setAccountDisabledPopup] = useState(false);
  const [disabledUserId, setDisabledUserId] = useState(null);
  const [isEnabling, setIsEnabling] = useState(false);
  // Set for phone accounts only: lets the user reactivate or start over.
  const [deletedAccount, setDeletedAccount] = useState(null);
  const [isDeletedBusy, setIsDeletedBusy] = useState(false);

  // Returns true if the account is blocked — callers should `return` right after.
  const checkAccountStatus = (user) => {
    if (user.IsDeleted) {
      if (user.PhoneNumber && user.CountyCode && Number(user.LoginBy) === 1) {
        setDeletedAccount({
          UserId: user.UserId,
          PhoneNumber: String(user.PhoneNumber),
          CountyCode: String(user.CountyCode),
        });
      }
      setAccountDeletedPopup(true);
      return true;
    }
    if (!user.IsActive) {
      setDisabledUserId(user.UserId);
      setAccountDisabledPopup(true);
      return true;
    }
    return false;
  };

  const handleReactivateAccount = async () => {
    try {
      setIsEnabling(true);
      const resp = await enable_user_account({ UserId: disabledUserId });
      if (resp?.code === 200) {
        setAccountDisabledPopup(false);
        setTimeout(() => navigate("/home"), 1000);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsEnabling(false);
    }
  };

  // Deleted account: bring it back, then the user logs in as before.
  const handleReactivateDeleted = async () => {
    try {
      setIsDeletedBusy(true);
      const resp = await signup_reactivate_account(deletedAccount);
      if (resp?.success) {
        setAccountDeletedPopup(false);
        setDeletedAccount(null);
        alert("Account reactivated. Please log in.");
        navigate("/home");
      } else {
        alert(resp?.message || "Failed to reactivate account");
      }
    } catch (error) {
      console.log(error);
      alert("Failed to reactivate account");
    } finally {
      setIsDeletedBusy(false);
    }
  };

  // Deleted account: wipe it from the database and continue as a new signup.
  const handleHardDeleteAndSignup = async () => {
    if (
      !window.confirm(
        "This permanently deletes the old account and all its data. This cannot be undone. Continue?",
      )
    ) {
      return;
    }
    try {
      setIsDeletedBusy(true);
      const resp = await signup_hard_delete_account(deletedAccount);
      if (resp?.success) {
        setAccountDeletedPopup(false);
        setDeletedAccount(null);
        navigate("/terms-and-conditions", { replace: true });
      } else {
        alert(resp?.message || "Failed to delete old account");
      }
    } catch (error) {
      console.log(error);
      alert("Failed to delete old account");
    } finally {
      setIsDeletedBusy(false);
    }
  };

  return {
    accountDeletedPopup,
    setAccountDeletedPopup,
    accountDisabledPopup,
    setAccountDisabledPopup,
    isEnabling,
    checkAccountStatus,
    handleReactivateAccount,
    deletedAccount,
    isDeletedBusy,
    handleReactivateDeleted,
    handleHardDeleteAndSignup,
  };
};
